"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _IconClose = _interopRequireDefault(require("../../icons/General/IconClose"));
var _Button = _interopRequireDefault(require("../Button"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Tag = ({
  icon,
  trackingEvent,
  trackingName,
  disabled,
  ...props
}) => {
  const Tag = (props.withclose || props.onClick) && !props.strictClose ? 'button' : 'div';
  return (0, _jsxRuntime.jsxs)(Tag, {
    title: props.title,
    className: props.className,
    onClick: !props.strictClose ? props.onClick : undefined,
    disabled: disabled,
    role: !props.strictClose && props.onClick ? 'button' : undefined,
    css: theme => [_styles.styles.default(theme), props.neutral && _styles.styles.neutral(theme), props.success && _styles.styles.success(theme), props.info && _styles.styles.info(theme), props.danger && _styles.styles.danger(theme), props.dark && _styles.styles.dark(theme), props.light && _styles.styles.light(theme), props.outline && _styles.styles.outline(theme), props.dotted && _styles.styles.dotted(theme), props.withclose && _styles.styles.withclose, props.strictClose && _styles.styles.strictClose, icon && _styles.styles.withicon, props.loading && _styles.styles.loading],
    children: [icon && icon, props.children, props.loading ? (0, _jsxRuntime.jsx)(_Spinner.default, {
      margin: "0 0 0 8px",
      size: 6,
      color: props.loadingColor
    }) : (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [props.withclose ? (0, _jsxRuntime.jsx)(_IconClose.default, {
        color: props.closeColor || 'white',
        size: '14px'
      }) : null, props.strictClose ? (0, _jsxRuntime.jsx)(_Button.default, {
        nostyle: true,
        onClick: props.onClick,
        trackingEvent: trackingEvent,
        trackingName: trackingEvent,
        disabled: disabled,
        children: (0, _jsxRuntime.jsx)(_IconClose.default, {
          color: props.closeColor || 'white',
          size: '14px'
        })
      }) : null]
    })]
  });
};
var _default = exports.default = Tag;